import { useMutation, useQueryClient } from '@tanstack/react-query';

import { GET_APP_TOKENS_QUERY_KEY } from './useGetAppTokens';

import AppTokensService, { AppToken } from '@/services/AppTokensService';

export function useRemoveAppToken() {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: (id: number) => AppTokensService.removeAppToken(id),
    onMutate: async (removedId) => {
      const previousTokens = queryClient.getQueryData(GET_APP_TOKENS_QUERY_KEY);

      queryClient.setQueryData(GET_APP_TOKENS_QUERY_KEY, (old: any) =>
        old?.filter((token: AppToken) => token.id !== removedId),
      );

      return { previousTokens };
    },
    onError: (_, __, context) => {
      if (context?.previousTokens) {
        queryClient.setQueryData(
          GET_APP_TOKENS_QUERY_KEY,
          context.previousTokens,
        );
      }
    },
  });

  return {
    removeAppToken: mutateAsync,
    isRemoving: isPending,
  };
}
